import type {
  NavigationGuardNext,
  RouteLocationNormalizedGeneric,
  RouteLocationNormalizedLoadedGeneric
} from 'vue-router'
import { signout } from '@/features/miiaFw/utils/miiaFwCognito'
import { useRouterUtils } from './useRouterUtils'
import { ROUTER_NAMES } from '@/constants/router/names'
import type { RouterPath } from '@/types/router/path'
import { GlobalError } from '@/utils/globalError/GlobalError'
import { ERROR_CODES } from '@/constants/error/errorCode'
import { useGovernmentSettingStore } from '@/stores/governmentSettingStore'
import { FeatureOptions } from '@/types/api/common/governmentSetting/queryGovernmentSettingResponseParam'

export const authorityGuard = async (
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedLoadedGeneric,
  next: NavigationGuardNext
) => {
  const governmentStore = useGovernmentSettingStore()
  const { getAuthorizedSupportPaths } = useRouterUtils()

  // App.vueの認証状態監視処理内で自治体設定が取得されるまで待機
  await governmentStore.waitLoad()
  if (!governmentStore.hasAuth(FeatureOptions.dupAuth)) {
    next({ name: ROUTER_NAMES.login })
    signout()
    new GlobalError(ERROR_CODES._811001_GOVERNMENT_SETTING_ERROR).showErrorMessage()
    return
  }

  // 自治体設定の機能オプション確認後、ユーザ属性を用いてアクセス可能な遷移先を取得する
  const authorizedPaths = await getAuthorizedSupportPaths(to.path as RouterPath).catch(() => [])
  if (authorizedPaths.some(e => e.path === to.path)) {
    // 遷移先の権限があればそのまま遷移
    next()
    return
  }

  if (authorizedPaths.length > 0) {
    // 権限があるいずれかのパスに遷移
    next(authorizedPaths[0])
    return
  }

  // 権限がないのでサインアウトし、エラーメッセージを表示する
  next({ name: ROUTER_NAMES.login })
  signout()
  new GlobalError(ERROR_CODES._811000_ROUTE_ACCESS_ERROR).showErrorMessage()
}
